import { useEffect, useState } from "react";
import {
  CITY_SUPPLY_DEMAND_LABELS,
  DEFAULT_MARKETPLACE_RANGE,
  formatPercent,
} from "../../../../constants/automapMarketplaceAnalyticsConstants";
import { fetchCityAnalytics } from "../../../../services/automapMarketplaceAnalyticsApi";
import { MarketplaceAnalyticsShell } from "./AdminMarketplaceAnalyticsShared";

export default function AdminCityAnalyticsPage() {
  const [range, setRange] = useState(DEFAULT_MARKETPLACE_RANGE);
  const [payload, setPayload] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState("");

  useEffect(() => {
    setLoading(true);
    setError("");
    fetchCityAnalytics(range)
      .then(setPayload)
      .catch((err) => setError(err.message || "Error al cargar analytics."))
      .finally(() => setLoading(false));
  }, [range]);

  return (
    <MarketplaceAnalyticsShell
      active="cities"
      title="Analytics por ciudad"
      description="Salud del marketplace por ciudad y balance oferta/demanda."
      range={range}
      onRangeChange={setRange}
      viewEvent="city_analytics_viewed"
    >
      {loading ? <p className="dealer-state-box">Cargando…</p> : null}
      {error ? <p className="dealer-state-box">{error}</p> : null}
      {!loading && !error ? (
        <section className="dealer-state-box">
          {!payload?.cities?.length ? (
            <p className="muted">Sin datos de ciudades en este periodo.</p>
          ) : (
            <table className="dealer-inventory-table">
              <thead>
                <tr>
                  <th>Ciudad</th>
                  <th>Activos</th>
                  <th>Dealers</th>
                  <th>Verificados</th>
                  <th>Sesiones</th>
                  <th>Búsquedas</th>
                  <th>Vistas</th>
                  <th>WhatsApp</th>
                  <th>Leads</th>
                  <th>Conv.</th>
                  <th>Frescura</th>
                  <th>Calidad</th>
                  <th>Balance</th>
                </tr>
              </thead>
              <tbody>
                {payload.cities.map((row) => (
                  <tr key={row.city}>
                    <td>{row.city}</td>
                    <td>{row.activeListings}</td>
                    <td>{row.activeDealers}</td>
                    <td>{row.verifiedDealers}</td>
                    <td>{row.buyerSessions}</td>
                    <td>{row.searches}</td>
                    <td>{row.vehicleDetailViews}</td>
                    <td>{row.whatsappClicks}</td>
                    <td>{row.leads}</td>
                    <td>{formatPercent(row.leadConversionRate)}</td>
                    <td>{formatPercent(row.inventoryFreshnessPercent)}</td>
                    <td>{row.averageListingQualityScore ?? "—"}</td>
                    <td>{CITY_SUPPLY_DEMAND_LABELS[row.supplyDemandBalance] || row.supplyDemandLabel}</td>
                  </tr>
                ))}
              </tbody>
            </table>
          )}
          <p className="muted" style={{ marginTop: "0.75rem" }}>
            Precio promedio/mediana disponible en filas expandidas (TODO: detalle por ciudad).
          </p>
        </section>
      ) : null}
    </MarketplaceAnalyticsShell>
  );
}
